module.exports = __webpack_public_path__ + "img/Perks-Gift-20.f0550f25.png";